// These are simply enums, NOT interfaces for what the back-end actually returns.
export enum SpendLevelTypeFieldNames {
  ABSOLUTE_DOLLARS = 'absoluteDollars',
  ABSOLUTE_UNITS = 'absoluteUnits',
  DOLLAR_MARKET_SHARE = 'dollarMarketShare',
  UNIT_MARKET_SHARE = 'unitMarketShare',
}

/*
 * @important Ask back-end to provide SHORT_DISPLAY_NAME.
 * */
export enum AbsoluteDollars {
  DISPLAY_NAME = 'Spend Volume',
  FIELD_NAME = 'absoluteDollars',
  NAME = 'ABSOLUTE_DOLLARS', // for legacy support only - use FIELD_NAME instead
  SHORT_DISPLAY_NAME = 'Vol',
  DESCRIPTION = 'Buyer commits this spend volume to the seller.',
}

export enum AbsoluteUnits {
  DISPLAY_NAME = 'Units Volume',
  FIELD_NAME = 'absoluteUnits',
  NAME = 'ABSOLUTE_UNITS', // for legacy support only - use FIELD_NAME instead
  SHORT_DISPLAY_NAME = 'Unit Vol',
  DESCRIPTION = 'Buyer commits this unit volume to the seller.',
}

export enum DollarMarketShare {
  DISPLAY_NAME = 'Spend Market Share',
  FIELD_NAME = 'dollarMarketShare',
  NAME = 'DOLLAR_MARKET_SHARE', // for legacy support only - use FIELD_NAME instead
  SHORT_DISPLAY_NAME = 'Spend MS',
  DESCRIPTION = 'Buyer commits this percentage of their spend to the seller.',
}

export enum UnitMarketShare {
  DISPLAY_NAME = 'Units Market Share',
  FIELD_NAME = 'unitMarketShare',
  NAME = 'UNIT_MARKET_SHARE', // for legacy support only - use FIELD_NAME instead
  SHORT_DISPLAY_NAME = 'Unit MS',
  DESCRIPTION = 'Buyer commits this percentage of their units to the seller.',
}

// When the tier value is zero - we sometimes replace it with the label "Access"
export enum ValueLabels {
  ZERO = 'Access',
}
export enum DollarVolume {
  DISPLAY_NAME = 'Spend Volume',
  FIELD_NAME = 'absoluteDollars',
  NAME = 'DOLLAR_VOLUME',
  SHORT_DISPLAY_NAME = 'Spend Vol',
}
export enum UnitVolume {
  DISPLAY_NAME = 'Units Volume',
  FIELD_NAME = 'absoluteUnits',
  NAME = 'UNIT_VOLUME',
  SHORT_DISPLAY_NAME = 'Unit Vol',
}

export enum And {
  DISPLAY_VALUE = 'And',
  VALUE = 'AND',
}

export enum Or {
  DISPLAY_VALUE = 'Or',
  VALUE = 'OR',
}

export const SpendLevelTypesMap = {
  absoluteDollars: AbsoluteDollars,
  absoluteUnits: AbsoluteUnits,
  dollarMarketShare: DollarMarketShare,
  unitMarketShare: UnitMarketShare,
};
